module.exports = __webpack_public_path__ + "static/Mumbai-e3dc020ac95861f60183d72b65802711.png";